'use client';

import useSWR from 'swr';

import { TypeDraftPlayGeniusOrderResponse } from '@/lib/api/orderManager/types/TypePlayGeniusOrder';

import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';

export default function useDraftOrders(
  userUuid: string,
  subscriptionUuid: string,
) {
  const uri = `${API_URLS.ORDER_MANAGER_PROXY}/users/${userUuid}/draft_orders?metadata[subscription_uuids]=${subscriptionUuid}`;

  const { data, isLoading, error, mutate } = useSWR<
    TypeDraftPlayGeniusOrderResponse,
    Error
  >(uri, SWR_REQUEST_DEFAULTS);

  return {
    draftOrdersData: data,
    draftOrdersLoading: isLoading,
    draftOrdersError: error,
    draftOrdersMutate: mutate,
  };
}
